import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes';
import SiteHeader from './components/layout/SiteHeader';
import SiteFooter from './components/layout/SiteFooter';
import './styles/App.css';
import './styles/components.css';
import './styles/home.css';

function App() {
  return (
    <Router>
      <div className="App">
        <SiteHeader />
        <Routes>
          {routes.map(({ path, element }, idx) => (
            <Route key={path || idx} path={path} element={element} />
          ))}
        </Routes>
        <SiteFooter />
      </div>
    </Router>
  );
}

export default App;
